import axios from "axios"

function options() {
  return { headers: { Authorization: localStorage.getItem("token") }, timeout: 10000 }
}

export default {
  fetchPerformance(params) {
    return axios.get("/api/performance", { ...options(), params }).then((response) => response.data)
  },
  setPerformanceEnabled(enabled) {
    return axios.put("/api/performance/state", { enabled }, options()).then((response) => response.data)
  },
}
